"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.whatsappRoutes = void 0;
const whatsappActions_openapi_1 = require("./whatsappActions.openapi");
const openapi = (name) => ({ openapi: whatsappActions_openapi_1.whatsappActionsOpenApiDocs[name] });
exports.whatsappRoutes = [
    {
        name: 'whatsapp.logout',
        path: ['/logout'],
        method: 'POST'
    },
    {
        name: 'whatsapp.settings.get',
        path: ['/settings'],
        method: 'GET'
    },
    {
        name: 'whatsapp.settings.getById',
        path: ['/settings/:id'],
        method: 'GET'
    },
    {
        name: 'whatsapp.settings.list',
        path: ['/settings/list'],
        method: 'GET'
    },
    {
        name: 'whatsapp.settings.create',
        path: ['/settings/create'],
        method: 'POST',
        plugins: {
            openapi: whatsappActions_openapi_1.whatsappActionsOpenApiDocs['whatsapp.settings.create']
        }
    },
    {
        name: 'whatsapp.settings.bulk-update',
        path: ['/settings/bulk'],
        method: 'POST',
        plugins: {
            openapi: whatsappActions_openapi_1.whatsappActionsOpenApiDocs['whatsapp.settings.bulk-update']
        }
    },
    {
        name: 'whatsapp.settings.save',
        path: ['/settings'],
        method: 'POST'
    },
    {
        name: 'whatsapp.settings.update',
        path: ['/settings/:id'],
        method: 'PUT'
    },
    {
        name: 'whatsapp.settings.updateEmail',
        path: ['/settings/:id/email'],
        method: 'PUT'
    },
    {
        name: 'whatsapp.settings.deleteEmail',
        path: ['/settings/:id/email'],
        method: 'DELETE'
    },
    {
        name: 'whatsapp.settings.delete',
        path: ['/settings/:id'],
        method: 'DELETE',
        plugins: {
            openapi: whatsappActions_openapi_1.whatsappActionsOpenApiDocs['whatsapp.settings.delete']
        }
    },
    {
        name: 'whatsapp.startAgent',
        path: ['/start-agent'],
        method: 'POST'
    },
    {
        name: 'whatsapp.stopAgent',
        path: ['/stop-agent'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.list',
        path: ['/groups/list/:settingsId'],
        method: 'GET'
    },
    {
        name: 'whatsapp.groups.get',
        path: ['/groups/:id'],
        method: 'GET'
    },
    {
        name: 'whatsapp.groups.setTracking',
        path: ['/groups/:id/tracking'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.messages',
        path: ['/groups/:id/messages'],
        method: 'GET'
    },
    {
        name: 'whatsapp.groups.create',
        path: ['/groups/create/:settingsId'],
        method: 'POST',
        plugins: {
            openapi: whatsappActions_openapi_1.whatsappActionsOpenApiDocs['whatsapp.groups.create']
        }
    },
    {
        name: 'whatsapp.groups.update',
        path: ['/groups/:id'],
        method: 'PUT'
    },
    {
        name: 'whatsapp.groups.members',
        path: ['/groups/:id/members'],
        method: 'GET'
    },
    {
        name: 'whatsapp.groups.updateMember',
        path: ['/groups/:id/members/:memberId'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.syncMembers',
        path: ['/groups/:id/members/sync'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.promoteMember',
        path: ['/groups/:id/promote'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.setAnnounce',
        path: ['/groups/:id/announce'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.summarize',
        path: ['/groups/:id/summarize'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.addParticipants',
        path: ['/groups/:id/add-participants'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.removeMember',
        path: ['/groups/:id/remove-member'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.summaries',
        path: ['/groups/:id/summaries'],
        method: 'GET'
    },
    {
        name: 'whatsapp.groups.syncMessages',
        path: ['/groups/:id/sync-messages'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.sendMessage',
        path: ['/groups/:id/send-message'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.downloadMedia',
        path: ['/messages/:messageId/download-media'],
        method: 'GET'
    },
    {
        name: 'whatsapp.view',
        path: ['/gate/view'],
        method: 'GET'
    },
    {
        name: 'whatsapp.groups.public_auth',
        path: ['/groups/public-auth'],
        method: 'POST'
    },
    {
        name: 'whatsapp.groups.trackLogs',
        path: ['/groups/:id/track-logs'],
        method: 'GET'
    },
    {
        name: 'whatsapp.trackLogs.all',
        path: ['/track-logs/:settingsId'],
        method: 'GET'
    },
    {
        name: 'whatsapp.activities.all',
        path: ['/activities'],
        method: 'GET'
    },
    {
        name: 'whatsapp.activities.stats',
        path: ['/activities/stats'],
        method: 'GET'
    },
    {
        name: 'whatsapp.trackLogs.handleAlert',
        path: ['/track-logs/handle-alert/:id'],
        method: 'POST'
    },
    {
        name: 'whatsapp.directMessages.list',
        path: ['/direct-messages/:settingsId'],
        method: 'GET'
    },
    {
        name: 'whatsapp.directMessages.trackLogs',
        path: ['/direct-messages/:settingsId/track-logs/:authorLid'],
        method: 'GET'
    },
    {
        name: 'whatsapp.directMessages.messages',
        path: ['/direct-messages/:settingsId/messages/:authorLid'],
        method: 'GET'
    },
    {
        name: 'whatsapp.directMessages.summaries',
        path: ['/direct-messages/:settingsId/summaries/:authorLid'],
        method: 'GET'
    },
    {
        name: 'whatsapp.directMessages.summarize',
        path: ['/direct-messages/:settingsId/summarize/:authorLid'],
        method: 'POST'
    },
    {
        name: 'whatsapp.directMessages.syncMessages',
        path: ['/direct-messages/:settingsId/sync-messages/:authorLid'],
        method: 'POST'
    },
    {
        name: 'whatsapp.directMessages.sendMessage',
        path: ['/direct-messages/:settingsId/send-message/:authorLid'],
        method: 'POST'
    },
    {
        name: 'whatsapp.email.trackLogs.all',
        path: ['/email/track-logs/:settingsId'],
        method: 'GET'
    },
    {
        name: 'whatsapp.email.directMessages.list',
        path: ['/email/direct-messages/:settingsId'],
        method: 'GET'
    },
    {
        name: 'whatsapp.email.directMessages.trackLogs',
        path: ['/email/direct-messages/:settingsId/track-logs/:emailAddress'],
        method: 'GET'
    },
    {
        name: 'whatsapp.email.trackLogs.handleAlert',
        path: ['/email/track-logs/handle-alert/:id'],
        method: 'POST'
    },
    {
        name: 'whatsapp.settings.gmail.auth',
        path: ['/settings/:id/gmail/auth'],
        method: 'POST'
    },
    {
        name: 'whatsapp.settings.gmail.callback',
        path: ['/settings/gmail/callback'],
        method: 'GET'
    },
    {
        name: 'whatsapp.settings.gmail.disconnect',
        path: ['/settings/:id/gmail/disconnect'],
        method: 'POST'
    },
    {
        name: 'whatsapp.threads.list',
        path: ['/threads/:settingsId'],
        method: 'GET'
    },
    {
        name: 'whatsapp.threads.trackLogs',
        path: ['/threads/:threadId/track-logs'],
        method: 'GET'
    },
    {
        name: 'whatsapp.threads.finish',
        path: ['/threads/:threadId/finish'],
        method: 'POST'
    },
    {
        name: 'whatsapp.threads.reopen',
        path: ['/threads/:threadId/reopen'],
        method: 'POST'
    }
];
